import React from "react";
import './GoldSpinner.css';

const GoldSpinner = ({ size = 48 }) => (
    <svg className="gold-spinner" width={size} height={size} viewBox="0 0 48 48" fill="none" role="status" aria-label="Loading">
        <circle cx="24" cy="24" r="20" stroke="#2E2E2E" strokeWidth="3" />
        <path d="M24 4a20 20 0 0 1 20 20" stroke="#B08D57" strokeWidth="3" strokeLinecap="round" />
    </svg>
);

export default GoldSpinner;
